export default "__VITE_ASSET__BXyuc2Sb__"